import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
interface SplashScreenProps {
  onComplete: () => void;
}
export const SplashScreen: React.FC<SplashScreenProps> = ({
  onComplete
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <div className="fixed inset-0 flex flex-col items-center justify-center bg-pirate-black overflow-hidden" data-id="element-165">
      <div className="absolute inset-0 bg-fire-texture opacity-20 bg-cover bg-center" data-id="element-166"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-pirate-black via-transparent to-pirate-black" data-id="element-167"></div>
      <div className="z-10 flex flex-col items-center px-4 text-center" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-169">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eFa5T1mpwhzi4xKfC4a9AH/LOGO_PERLA_NEGRA.png" alt="Perla Negra Logo" className="w-64 md:w-80" data-id="element-170" />
        </motion.div>
        <motion.h1 initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1,
        duration: 1
      }} className="font-pirata text-2xl md:text-4xl text-white mb-6" data-id="element-171">
          ¡Bienvenido a bordo del Perla Negra!
        </motion.h1>
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 1
      }} className="text-lg md:text-xl mb-8 max-w-2xl" data-id="element-172">
          Donde los piratas del sabor conquistan el mar del buen gusto.
        </motion.p>
        <motion.button initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 2,
        duration: 0.5
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={onComplete} className="bg-pirate-red border-2 border-white px-6 py-3 rounded-md font-pirata text-xl animate-pulse-slow hover:animate-none focus:outline-none focus:ring-2 focus:ring-white" data-id="element-173">
          ¡Abordar el barco!
        </motion.button>
      </div>
    </div>;
};